import { HttpClient } from 'core/common/services';
import { UserReading, UserReadingParams } from '../../entities';
import { UserReadingServiceInterface } from './UserReadingServiceInterface';

export class UserReadingService implements UserReadingServiceInterface {
  constructor(private readonly httpClient: HttpClient) {}

  async addReading(params: UserReadingParams): Promise<UserReading[]> {
    const { data } = await this.httpClient.post<UserReading[]>('/readings/create-reading', {
      data: params,
    });

    return data;
  }
}
